<template>
  <v-card>
    <v-form v-model="formValid">
      <v-col
        cols="12"
      >
        <v-text-field
          v-model="form.text"
          label="Text upozornění"
          required
          :rules="[rules.required]"
        ></v-text-field>
      </v-col>

      <v-col
        cols="12"
      >
        <v-checkbox v-model="form.active" label="Aktivní"></v-checkbox>
      </v-col>
      <v-col
        cols="12"
      >
        <v-select
          v-model="form.type"
          :items="alertTypes"
          :search-input.sync="search"
          hide-selected
          item-text="name"
          label="Typ upozornění"
          persistent-hint
          :rules="[rules.required]"
        >
        </v-select>
      </v-col>
      <v-col cols="6" class="text-right">
      <v-btn
        :disabled="!formValid || wait"
        color="warning"
        class="mr-4"
        @click="save"
      >
        Zapsat
      </v-btn>
    </v-col>
    </v-form>
  </v-card>
</template>

<script>
import rules from '../../../mixins/rules'

export default {
  props: ['item'],
  mixins: [rules],
  name: 'AlertsForm',
  data () {
    return {
      wait: false,
      formValid: true,
      form: {
        id: this.item.id,
        text: this.item.text,
        type: this.item.type,
        active: this.item.active
      },
      alertTypes: [{
        name: 'Info',
        value: 0
      },
      {
        name: 'Upozornění',
        value: 1
      },
      {
        name: 'Výstraha',
        value: 2
      }],
      search: false
    }
  },
  methods: {
    save () {
      Object.keys(this.form).forEach(key => {
        if (typeof this.form[key] === 'string') {
          this.form[key] = this.form[key].trim()
        }
      })
      this.wait = true
      const options = {
        method: this.form.id ? 'put' : 'post',
        url: `/admin/alerts${this.form.id ? '/' + this.form.id : ''}`,
        data: this.keysToSnakeCase(this.form)
      }
      this.$http(options)
        .then(() => {
          this.wait = false
          this.$emit('data-saved')
        })
        .catch(err => {
          this.wait = false
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>

</style>
